import { Unidade } from './unidade';

export class Perspectiva {
	idPerspectiva:number;
	nmPerspectiva: number;
	dtImplantacao:Date;
	dtTermino:Date;
	unidade:Unidade;
	usuariosAlteracao:number;
}






